module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    on: {
      "click": _vm.open
    }
  }, [_vm._t("activator")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-placeholder",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-bg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._t("header")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_vm._t("toolbar")], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2)])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67567d5b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 504
// module chunks = 1